const baseURLVer1 = '/api/v1/board';

export default {
  /**
   * @PUT 게시글 읽음 처리
   */
  BOARD_READ: (documentId: string) => `${baseURLVer1}/read/${documentId}`,
  /**
   * @GET 게시글 검색
   */
  BOARD_SEARCH: baseURLVer1,
  /**
   * @param documentId
   * @GET 게시글 조회
   * @DELETE 게시글 삭제
   */
  // PORTAL-8155 OpenSearch 운영까지 적용.
  BOARD_DETAIL: (documentId: string) => `${baseURLVer1}/search/${documentId}`,
  /**
   * @DELETE 게시글 삭제
   */
  BOARD_DELETE: (documentId: string) => `${baseURLVer1}/${documentId}`,
  /**
   * @param documentId 게시글 아이디
   * @GET 피드백 유저 정보 조회
   * @PUT 피드백 활성화
   * @DELETE 피드백 활성화 취소
   */
  BOARD_FEEDBACK: (documentId: string) =>
    `${baseURLVer1}/feedback/${documentId}`,
  /**
   * @Get 게시글 카테고리 조회
   */
  BOARD_CATEGORY_LIST_FILTER: (params = '') =>
    `${baseURLVer1}/category/list/filter${params}`,
  /**
   * @POST 게시글 작성
   */
  BOARD_CREATE: `${baseURLVer1}/create`,
  /**
   * @PUT 게시글 수정
   */
  BOARD_UPDATE: `${baseURLVer1}/update`,
  /**
   * @POST 게시글 배포
   */
  BOARD_DEPLOY: (documentId: string) => `${baseURLVer1}/deploy/${documentId}`,
  /**
   * @GET 게시글 배포 상태 조회
   */
  BOARD_DEPLOY_STATUS: (documentId: string) =>
    `${baseURLVer1}/deploy/${documentId}`,
  /**
   * @POST 게시물 카테고리 생성
   * body: { name, description, sortNumber, groupId, acl?: [{role, scope:{type,value}}] }
   */
  BOARD_CATEGORY_CREATE: `${baseURLVer1}/category/create`,
  /**
   * @GET 게시물 카테고리 단건 조회 (ACL 목록 포함)
   * @PUT 게시물 카테고리 수정 (body: { categoryId, name, description })
   * @DELETE 게시물 카테고리 삭제
   */
  BOARD_CATEGORY_DETAIL: (categoryId: string) =>
    `${baseURLVer1}/category/${categoryId}`,
  /**
   * @GET 게시물 카테고리 ACL 조회 (대상 단위 그룹핑된 단일 목록. 각 항목 scopes 포함)
   * @PUT 게시물 카테고리 ACL 부여 (신규/업서트, scope 기반)
   * @DELETE 게시물 카테고리 ACL 제거 (body: { type, value } → 대상의 acl 전부 제거)
   */
  BOARD_CATEGORY_ACL_LIST: (categoryId: string) =>
    `${baseURLVer1}/category/${categoryId}/acl`,
  /**
   * @PUT 게시물 카테고리 ACL 역할 변경 (body: { type, value, role }.
   *      기존 acl 제거 후 새 role 부여를 한 요청으로 원자 처리 → 204)
   */
  BOARD_CATEGORY_ACL_REPLACE: (categoryId: string) =>
    `${baseURLVer1}/category/${categoryId}/acl/replace`,
  /**
   * @DELETE 게시물 카테고리 ACL 제거 (aclId 기반, 신규 흐름에선 미사용)
   */
  BOARD_CATEGORY_ACL_ITEM: (categoryId: string, aclId: string) =>
    `${baseURLVer1}/category/${categoryId}/acl/${aclId}`,
  /**
   * @GET 카테고리 그룹 목록 조회 (노출 필터된 그룹. 각 항목 createdBy/sortNumber 포함)
   */
  BOARD_CATEGORY_GROUP_LIST: `${baseURLVer1}/category/group`,
  /**
   * @POST 카테고리 그룹 생성 (body: { name, sortNumber? } → { data: { groupId, createdBy } })
   */
  BOARD_CATEGORY_GROUP_CREATE: `${baseURLVer1}/category/group/create`,
  /**
   * @PUT 카테고리 그룹 이름 변경 (body: { name }. createdBy 미일치 && board_full_access 아님 → 403)
   * @DELETE 카테고리 그룹 삭제 (묶음 해제: 내부 카테고리는 groupId=null 처리, idempotent)
   */
  BOARD_CATEGORY_GROUP_ITEM: (groupId: string) =>
    `${baseURLVer1}/category/group/${groupId}`,
};
